import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';
import {FormattedMessage} from 'react-intl';
import { Editor } from '@tinymce/tinymce-react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';

import FormContext from './FormContext';
import {HelpButton} from '../../common/button';
import dataUtils from '../../../util/DataUtils';

const textField = ({disabled, field, fullWidth, helpButton, input, label, messageId, intl, meta, meta: {active, error, touched, warning}, onKeyDown, ...rest}) => {

    const editorRef = useRef(null);
    function handleKeyDown(e) {
        if ((e.keyCode === 13 && !e.shiftKey && !!onKeyDown) || (e.keyCode === 9)) {
            e.stopPropagation();
        }      
    }

    function handleOnBlur(e) {
        return input.onBlur(dataUtils.trimField(e));
    }

    function handleOnChange(e){
        return input.onChange(e);
    }

    return (
        <FormControl disabled={disabled} fullWidth={fullWidth === undefined ? true : fullWidth}>
            <p></p>
            <InputLabel htmlFor={field} shrink>
                {messageId ? <FormattedMessage id={messageId}/> : label}
                {helpButton && !React.isValidElement(helpButton) ? <HelpButton {...helpButton}/> : helpButton}
            </InputLabel>    
            <Editor
                apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                id={field}
                spellCheck
                {...input}
                {...rest}
                onInit={(evt, editor) => editorRef.current = editor}
                onKeyDown={handleKeyDown}
                onBlur={handleOnBlur}
                onEditorChange={handleOnChange}                
                init={{
                height: 200,
                menubar: false,                
                skin: 'small',
                icons:'thin',
                language:intl.messages['config.tinymceLanguage'],
                plugins: [
                    'advlist', 'lists', 'charmap', 'preview',
                    'searchreplace', 'visualblocks', 'code',
                    'insertdatetime', 'help', 'wordcount'
                ],
                toolbar: 'fontfamily fontsize inline bold italic underline forecolor blocks visualblocks bullist numlist outdent indent',
                content_style: 'body { background-color: #2a2a2a; color: #fff; font-family:Helvetica,Arial,sans-serif; font-size:14px; line-height: 1.4; margin: 1rem; }',
                statusbar: false
                }}
            />            
            <FormHelperText error={!!error ? !!error : undefined}>
                {do {
                    if (((active && input.value) || touched) && !!error) {
                        error;
                    } else if (active && !error && !!warning) {
                        warning;
                    }
                }}
            </FormHelperText>
        </FormControl>
    );
};

const RichTextInput = ({field, label, show, type, ...rest}) => {

    if (show !== undefined && !show) {
        return null;
    }

    return (
        <FormContext.Consumer>
            {context => {
                return (
                    <span className="input">
                        <Field
                            component={textField}
                            field={field}
                            label={label}
                            name={field}
                            onKeyDown={context.handleKeyDown}
                            normalize={dataUtils.normalizeField(type)}
                            type={type}
                            {...rest}
                        />
                    </span>
                );
            }}
        </FormContext.Consumer>
    );
};

RichTextInput.propTypes = {
    field: PropTypes.string.isRequired,
    fullWidth: PropTypes.bool,
    helpButton: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.object
    ]),
    label: PropTypes.string,
    messageId: PropTypes.string,
    show: PropTypes.bool,
    type: PropTypes.string,
    intl: PropTypes.object
};

export default RichTextInput;


// WEBPACK FOOTER //
// ./src/components/common/form/RichTextInput.js